module.exports = __webpack_public_path__ + "img/configurator-promo-shadow-2.c45ea1ba.png";